
const makeCapitalizeWord = (word:string) =>
    word.replace(/^\w/, c => c.toUpperCase());

export default makeCapitalizeWord;